import { cn } from '@/util/cn';
import { useOTSTranslation } from '@/i18n/useOTSTranslation';

interface ICurrencyNoticeProps {
  className?: string
  currency: string
}

const CurrencyNotice = ({ className, currency }: ICurrencyNoticeProps) => {
  const { t } = useOTSTranslation('common');

  return (
    <div className={cn('text-[0.6375rem] text-foreground/55', className)}>
      {`${t('resort.liftTickets.currencyText')} `}
      {currency}
    </div>
  );
};

export default CurrencyNotice;
